import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to fetch and sort all events
export const fetchAllEvents = createAsyncThunk(
    'events/fetchAllEvents',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('api/v1/get_all_events');
            const all = response.data.events || [];

            // Sort by id descending
            const sorted = all.sort((a, b) => b.id - a.id);
            return sorted;
        } catch (err) {
            console.error('Failed to fetch events:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const eventsSlice = createSlice({
    name: 'events',
    initialState: {
        allEvents: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllEvents(state, action) {
            state.allEvents = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllEvents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllEvents.fulfilled, (state, action) => {
                state.loading = false;
                state.allEvents = action.payload;
            })
            .addCase(fetchAllEvents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllEvents } = eventsSlice.actions;
export default eventsSlice.reducer;
